import { useState, useEffect } from 'react';
import { zonesAPI } from '../services/api';

export const useZones = () => {
    const [zones, setZones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchZones = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await zonesAPI.getAll();
            setZones(response.data.zones);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchZones();
    }, []);

    return { zones, loading, error, refetch: fetchZones };
};

export const useZoneRecords = (zoneId) => {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchRecords = async () => {
        if (!zoneId) return;

        try {
            setLoading(true);
            setError(null);
            const response = await zonesAPI.getRecords(zoneId);
            setRecords(response.data.records);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRecords();
    }, [zoneId]);

    return { records, loading, error, refetch: fetchRecords };
};
